import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";
import SiteShell from "../components/site/SiteShell";

export default function PayCancelPage() {
  return (
    <SiteShell>
      <section className="min-h-[60vh] flex items-center py-20" data-testid="pay-cancel-section">
        <div className="max-w-[560px] w-full mx-auto px-6 text-center">
          <XCircle className="mx-auto text-white/60 mb-6" size={48} strokeWidth={1.4} />
          <h1 className="h-display text-white text-[36px] mb-4">PAYMENT <span className="text-white/60">CANCELLED.</span></h1>
          <p className="text-white/65 mb-8">No charge was made. You can retry from the email we sent, or reach out and we'll help.</p>
          <div className="flex gap-3 justify-center flex-wrap">
            <Link to="/contact" className="btn-gold btn-label">Contact Us <ArrowRight size={14} /></Link>
            <Link to="/" className="btn-outline-gold btn-label">Back to Home</Link>
          </div>
        </div>
      </section>
    </SiteShell>
  );
}
